/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-down-to-bottom': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 11.875l-6.25-6.25.881-.881L10 10.106l5.369-5.362.881.881-6.25 6.25zm-7.5 2.5h15v1.25h-15v-1.25z"/>'
  }
})
